import { Injectable } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { ModalService } from 'mbs-ui-kit';
import { from } from 'rxjs';
import { RMMGroupActionWizardComponent } from '../rmm-group-action-wizard.component';

@Injectable()
export class LoadRmmGroupTaskWizardService {
  constructor(private i18next: I18NextService, private modalService: ModalService) {}

  loadWizard() {
    return from(this.modalService.openWizard(RMMGroupActionWizardComponent));
  }
}
